var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topbar',{attrs:{"titulo":_vm.$t('FINANCEIRO.GERENCIAR_BOLETOS'),"subtitulo":_vm.$t('FINANCEIRO.GERENCIAR_BOLETOS_DESCRICAO'),"breadcrumbs":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }